import React from 'react';
import { motion } from 'framer-motion';
import { Shield, MapPin, CalendarCheck, Headphones } from 'lucide-react';
export function TrustSection() {
  const trustSignals = [{
    icon: <Shield className="w-6 h-6" data-id="element-155" />,
    text: 'DSGVO-konform'
  }, {
    icon: <MapPin className="w-6 h-6" data-id="element-156" />,
    text: 'Server in Deutschland'
  }, {
    icon: <CalendarCheck className="w-6 h-6" data-id="element-157" />,
    text: 'Monatlich kündbar'
  }, {
    icon: <Headphones className="w-6 h-6" data-id="element-158" />,
    text: 'Persönlicher Support'
  }];
  return <section className="py-12 bg-white border-b border-gray-100" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center min-h-[120px]" data-id="element-160">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16" data-id="element-161">
          {trustSignals.map((signal, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center text-gray-600" data-id="element-162">
              <div className="text-brand-accent mr-3" data-id="element-163">{signal.icon}</div>
              <span className="font-medium" data-id="element-164">{signal.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}